module.exports = __webpack_public_path__ + "img/conference8.741bb665.png";